/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { loopPaceSchema } from './loopPaceSchema';

export const loopFinancialsSchema = z.object({
  actualCost: z
    .string()
    .describe("Sum of rolled actual cost across the loop's valid top-level items")
    .nullish(),
  actualCostCompletenessStatus: z
    .enum(['COMPLETE', 'INCOMPLETE', 'PRESERVED', 'UNAVAILABLE'])
    .describe(
      "Least-complete actual-cost status across the loop's valid top-level items: COMPLETE, INCOMPLETE, PRESERVED, or UNAVAILABLE (also used for a top-level item with no computed aggregate at all).",
    ),
  budgetedCost: z
    .string()
    .describe("Sum of effective budget (budgeted cost) across the loop's valid top-level items")
    .nullish(),
  budgetedMargin: z
    .string()
    .describe(
      'Budgeted margin: effectiveForecastRevenue minus budgetedCost. Null if either is unavailable.',
    )
    .nullish(),
  budgetSpentPercentage: z
    .string()
    .describe(
      'actualCost / budgetedCost * 100. Null when either is unavailable. When budgetedCost is exactly zero, this is 100 if any actual cost was incurred, otherwise 0.',
    )
    .nullish(),
  capexBudgetTotal: z
    .string()
    .describe(
      "Sum of CapEx-attributed budget across the loop's valid top-level items. Null if any item with a budget is missing its CapEx percentage, rather than silently omitting that item's share.",
    )
    .nullish(),
  computedAt: z.iso
    .datetime()
    .describe(
      "Most recent computedAt across the loop's contributing top-level items — when the loop's financials last changed. Null when the loop has top-level items but none of them have computed financials yet.",
    )
    .nullish(),
  effectiveForecastRevenue: z
    .string()
    .describe("Sum of effective forecast revenue across the loop's valid top-level items")
    .nullish(),
  opexBudgetTotal: z
    .string()
    .describe(
      "Sum of OpEx-attributed budget across the loop's valid top-level items. Null under the same condition as capexBudgetTotal.",
    )
    .nullish(),
  get pace() {
    return z.union([loopPaceSchema, z.null()]).optional();
  },
  scheduleElapsedPercent: z
    .string()
    .describe(
      "Elapsed percentage (0-100) of the loop's schedule window: earliest top-level plannedStartDateTime to latest top-level plannedFinishDateTime, as of today. Null if that window can't be determined.",
    )
    .nullish(),
});
